import { FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { UpsellButton } from 'modules/finance/components/FinancialWorkspace/components/UpsellingButton'
import { REQUEST_SOURCE } from 'modules/finance/components/FinancialWorkspace/consts/requestSource'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

export const CompensationsUpsellButton: FC<{
  requestComponent: string
}> = ({ requestComponent }) => {
  const buttonTexts = {
    requested: i18n.t('finance.financial_workspace.payroll.landing.buttons.requested'),
    unlock: i18n.t('finance.financial_workspace.compensations.upload_banner.cta.unlock'),
  }

  return (
    <Box data-testid="compensations-upsell-button">
      <UpsellButton
        moduleRequested={AvailableModules.compensations}
        reason={ValidReasons.MissingAddon}
        requestSource={
          requestComponent ? `${REQUEST_SOURCE} - ${requestComponent}` : REQUEST_SOURCE
        }
        pageSource={REQUEST_SOURCE}
        buttonTexts={buttonTexts}
      />
    </Box>
  )
}
